export default __webpack_public_path__ + "static/media/Draft App Icon.32f898dc.jpg";